import { get } from 'lodash';
import React from 'react';
import { getLocalstorageToken } from 'src/context/AuthHelper';
import { KOSTEN_ARTEN, KOSTEN_POSITION } from 'src/lib/constants/constant';
import { TreeNodeType } from 'src/lib/types/types';
import { TreeStructureAntragAbschlussSeiteGlobal } from '../../global-structure/abschluss-seite/TreeStructureAbschlussSeiteGlobal';
import { TreeStructureAllgemeinHinweisGlobal } from '../../global-structure/allgemeinen-hinweis/TreeStructureAllgemeinHinweisGlobal';
import { TreeStructureAnlagenGlobal } from '../../global-structure/anlagen/TreeStructureAnlagenGlobal';
import { TreeStructureAntragBescheidGlobal } from '../../global-structure/antrag-bescheid/TreestructureAntragBescheidGlobal';
import { TreeStructureAntragstellerGlobal } from '../../global-structure/antragstellerin/TreeStructureAntragstellerGlobal';
import { TreeStructureDeMinimisGlobal } from '../../global-structure/de-minimis/TreeStructureDeMinimisGlobal';
import { TreeStructureErklaerungGlobal } from '../../global-structure/erklaerung/TreeStructureErklaerungGlobal';
import { TreeStructureAntragFinanzierungsPlanGlobal } from '../../global-structure/finanzierung-plan-antrag/TreeStructureAntragFinanzierungsPlanGlobal';
import { TreeStructureSelbstErklaerungRUSGlobal } from '../../global-structure/rus-erklaerung/TreeStructureSelbstErklaerungRUSGlobal';
import { TreeStructureSelbstErklaerungBeihilferelevanzGlobal } from '../../global-structure/beihilferelevanz-erklaerung/TreeStructureSelbstErklaerungBeihilferelevanzGlobal';
import { TreeStructureSelbstErklaerungKMUGlobal } from '../../global-structure/selbst-erklaerung-kmu/TreeStructureSelbstErklaerungKMUGlobal';
import { TreeStructureAntragVorzeitigerMassnahme } from '../../global-structure/vorzeitige-massnahme/TreeStructureVorzeitigeMassnahmeGlobal';
import { TreeStructureZeitplanungGlobal } from '../../global-structure/zeitplanung/TreeStructureZeitplanungGlobal';
import AntragAufProjektFoerderungAntragStartupProjekte from './content/antrag-auf-projektfoerderung/AntragAufProjektFoerderungAntragStartupProjekte';
import DurchfuehrungAntragStartupProjekte, {
	getFormStrucDurchfuehrungAntragStartupProjekte,
} from './content/antrag-auf-projektfoerderung/children/DurchfuehrungAntragStartupProjekte';
import ErfolgskontrolleAntragStartupProjekte, {
	getFormStrucErfolgskontrolleAntragStartupProjekte,
} from './content/antrag-auf-projektfoerderung/children/ErfolgskontrolleAntragStartupProjekte';
import VorhabensbeschreibungAntragStartupProjekte, {
	getFormStrucVorhabensbeschreibungAntragStartupProjekte,
} from './content/antrag-auf-projektfoerderung/children/VorhabensbeschreibungAntragStartupProjekte';
import EigenmittelAntragStartupProjekte, { getFormStrucEigenmittelAntragStartupProjekte } from './content/EigenmittelAntragStartupProjekte';
import EinnahmeUebersichtAntragStartupProjekte from './content/EigenmittelUebersichtAntragStartupProjekte';
import PersonalKostenStartupProjekte, { getFormStrucPersonalKostenStartupProjekte } from './content/PersonalKostenStartupProjekte';
import PersonalKostenUebersichtStartupProjekte from './content/PersonalKostenUebersichtStartupProjekte';
import ProjektdatenAntragStartUpProjekte, { getFormStrucProjektdatenAntragStartUpProjekte } from './content/ProjektdatenAntragStartUpProjekte';
import SachkostenAntragStartupProjekte, { getFormStrucSachkostenAntragStartupProjekte } from './content/SachkostenAntragStartupProjekte';
import SachkostenUebersichtAntragStartupProjekte from './content/SachkostenUebersichtAntragStartupProjekte';

// import schemas
import Schema from 'src/lib/paths/antrag_FULL_Paths.json';
import {
	checkIfAllPositionIsEditable,
	checkIfAnyPositionNachKostenArtHasComment,
	checkIfHasComment,
	checkIfProjektDatenHasComment,
} from '../../../application-helper-function/PruefAssistenzHelperFunktion';
const P = Schema.attributes;

export const TreeStructureAntragStartupProjekte = (
	application: any,
	readOnly: boolean,
	kostenKategoriesGroup: any,
	allgemeineHinweiseKMU: any,
	allgemeineHinweiseDeminimis: any,
	allgemeineHinweiseRUS: any,
	allgemeineHinweiseBeihilferelevanz: any,
) => {
	const hasCommentProjektdaten = checkIfProjektDatenHasComment(readOnly, application);
	const isKostenEditable = checkIfAllPositionIsEditable(readOnly, application);

	let treeNodes: TreeNodeType[] = [
		// Allgemeine Hinweise Global
		...TreeStructureAllgemeinHinweisGlobal(application),
		// Projektdaten
		{
			label: 'Projektdaten',
			content: <ProjektdatenAntragStartUpProjekte hasComment={hasCommentProjektdaten} />,
			formStruc: getFormStrucProjektdatenAntragStartUpProjekte(application),
			hasComment: hasCommentProjektdaten,
		},
		// Antragsteller Global
		...TreeStructureAntragstellerGlobal(application, readOnly),
		// Selbsterlärung-KMU Global
		...TreeStructureSelbstErklaerungKMUGlobal(application, readOnly, allgemeineHinweiseKMU),
		// Beihilferelevanz-Erklärungen Global
		...TreeStructureSelbstErklaerungBeihilferelevanzGlobal(application, readOnly, allgemeineHinweiseBeihilferelevanz),
		// RUS-Erklärungen Global
		...TreeStructureSelbstErklaerungRUSGlobal(application, readOnly, allgemeineHinweiseRUS),
		// Deminismis-Selbsterklärung Global
		...TreeStructureDeMinimisGlobal(application, readOnly, allgemeineHinweiseDeminimis),
		// Projektbeschreibung
		...ProjektbeschreibungStructure(application, readOnly),
		// Zeitplanung Global
		...TreeStructureZeitplanungGlobal(application, readOnly),
		// Kosten
		...PersonalKostenStructure(application, kostenKategoriesGroup, readOnly, isKostenEditable),
		...SachkostenStructure(application, kostenKategoriesGroup, readOnly, isKostenEditable),
		...EigenmittelStructure(application, kostenKategoriesGroup, readOnly, isKostenEditable),
		// Finanzierungplan Global
		...TreeStructureAntragFinanzierungsPlanGlobal(application, isKostenEditable),
		// Anlagen und Erklärung Global
		...TreeStructureAnlagenGlobal(application, readOnly),
		...TreeStructureErklaerungGlobal(application, readOnly),
		// Vorzeitiger Massnahme Global
		...TreeStructureAntragVorzeitigerMassnahme(application, readOnly),
		// Abschluss Global
		...TreeStructureAntragAbschlussSeiteGlobal(application, readOnly),
		// Bescheid Global
		...TreeStructureAntragBescheidGlobal(application),
	];

	return treeNodes;
};

const ProjektbeschreibungStructure = (application: any, readOnly: boolean) => {
	const hasCommentVorhabensbeschreibung = checkIfHasComment(
		readOnly,
		application,
		P.Projektbeschreibung_Start_Up_Projekte.schema.attributes.Pruefung_Vorhabensbeschreibung_Pruefstatus.path,
	);
	const hasCommentDurchfuehrung = checkIfHasComment(
		readOnly,
		application,
		P.Projektbeschreibung_Start_Up_Projekte.schema.attributes.Pruefung_Durchfuehrung_Pruefstatus.path,
	);
	const hasCommentErfolgskontrolle = checkIfHasComment(
		readOnly,
		application,
		P.Projektbeschreibung_Start_Up_Projekte.schema.attributes.Pruefung_Erfolgskontrolle_Pruefstatus.path,
	);
	let nodes: TreeNodeType[] = [
		{
			label: 'Projektbeschreibung',
			content: <AntragAufProjektFoerderungAntragStartupProjekte />,
			hasComment: hasCommentErfolgskontrolle || hasCommentDurchfuehrung || hasCommentVorhabensbeschreibung,
			children: [
				{
					label: 'Projektbeschreibung',
					content: <VorhabensbeschreibungAntragStartupProjekte hasComment={hasCommentVorhabensbeschreibung} />,
					formStruc: getFormStrucVorhabensbeschreibungAntragStartupProjekte(application),
					hasComment: hasCommentVorhabensbeschreibung,
				},
				{
					label: 'Durchführung',
					content: <DurchfuehrungAntragStartupProjekte hasComment={hasCommentDurchfuehrung} />,
					formStruc: getFormStrucDurchfuehrungAntragStartupProjekte(application),
					hasComment: hasCommentDurchfuehrung,
				},
				{
					label: 'Erfolgskontrolle',
					content: <ErfolgskontrolleAntragStartupProjekte hasComment={hasCommentErfolgskontrolle} />,
					formStruc: getFormStrucErfolgskontrolleAntragStartupProjekte(application),
					hasComment: hasCommentErfolgskontrolle,
				},
			],
		},
	];
	return nodes;
};
const PersonalKostenStructure = (application: any, kostenKategoriesGroup: any, readOnly: boolean, hasCommentAusgabenUndFinanzierung?: boolean) => {
	if (get(kostenKategoriesGroup, KOSTEN_POSITION.Ausgabe, []).includes(KOSTEN_ARTEN.Personalkosten)) {
		return [
			{
				label: 'Personalkosten',
				content: (
					<PersonalKostenStartupProjekte
						kostentraeger='Antragsteller'
						unternehmenId={get(getLocalstorageToken(), 'organisationId')}
						hasComment={hasCommentAusgabenUndFinanzierung}
					/>
				),
				hasComment: checkIfAnyPositionNachKostenArtHasComment(readOnly, application, KOSTEN_ARTEN.Personalkosten),
				formStruc: getFormStrucPersonalKostenStartupProjekte(application, get(getLocalstorageToken(), 'organisationId')),
			},
			{
				label: 'Personalkosten Übersicht',
				content: <PersonalKostenUebersichtStartupProjekte />,
				isSummaryReport: true,
			},
		];
	}
	return [];
};
const SachkostenStructure = (application: any, kostenKategoriesGroup: any, readOnly: boolean, hasCommentAusgabenUndFinanzierung?: boolean) => {
	if (get(kostenKategoriesGroup, KOSTEN_POSITION.Ausgabe, []).includes(KOSTEN_ARTEN.Sachkosten)) {
		return [
			{
				label: 'Sachausgaben',
				content: (
					<SachkostenAntragStartupProjekte
						kostentraeger='Antragsteller'
						unternehmenId={get(getLocalstorageToken(), 'organisationId')}
						hasComment={hasCommentAusgabenUndFinanzierung}
					/>
				),
				hasComment: checkIfAnyPositionNachKostenArtHasComment(readOnly, application, KOSTEN_ARTEN.Sachkosten),
				formStruc: getFormStrucSachkostenAntragStartupProjekte(application, get(getLocalstorageToken(), 'organisationId')),
			},
			{
				label: 'Sachausgaben Übersicht',
				content: <SachkostenUebersichtAntragStartupProjekte />,
				isSummaryReport: true,
			},
		];
	}
	return [];
};
const EigenmittelStructure = (application: any, kostenKategoriesGroup: any, readOnly: boolean, hasCommentAusgabenUndFinanzierung?: boolean) => {
	if (get(kostenKategoriesGroup, KOSTEN_POSITION.Einnahme, []).includes(KOSTEN_ARTEN.Eigenmittel)) {
		return [
			{
				label: 'Eigen- und Drittmittel',
				content: (
					<EigenmittelAntragStartupProjekte
						kostentraeger='Antragsteller'
						unternehmenId={get(getLocalstorageToken(), 'organisationId')}
						hasComment={hasCommentAusgabenUndFinanzierung}
					/>
				),
				hasComment: checkIfAnyPositionNachKostenArtHasComment(readOnly, application, KOSTEN_ARTEN.Eigenmittel),
				formStruc: getFormStrucEigenmittelAntragStartupProjekte(application, get(getLocalstorageToken(), 'organisationId')),
			},
			{
				label: 'Eigen- und Drittmittel Übersicht',
				content: <EinnahmeUebersichtAntragStartupProjekte />,
				isSummaryReport: true,
			},
		];
	}
	return [];
};
